const TechnicalSkillDetails = () => {
  return <div>test</div>;
};

export default TechnicalSkillDetails;
